/* eslint-disable */

import React from 'react';
import { IRouteDetailsDataBlobPreset } from '../../../../../../sp-types/routeDetailsType';
import { DataBlobPresetTypes } from '@pages/Policy/RouteDetails/routeDetailsUtils';
import { RouteDetailsDataBlob } from '../RouteDetailsDataBlob';

export const RouteDetailsDataBlobPreset: React.FC<IRouteDetailsDataBlobPreset> = ({ route, currentType }) => {
  return (
    <div className="flex flex-row gap-4">
      {DataBlobPresetTypes.hasOwnProperty(currentType) && route && route.prices && (
        <RouteDetailsDataBlob
          icon={DataBlobPresetTypes[currentType].icon}
          dataList={DataBlobPresetTypes[currentType].getDataList(route)}
          title={currentType === 'price-main-price' ? route.name : DataBlobPresetTypes[currentType].title}
          isAlert={DataBlobPresetTypes[currentType].isAlert}
        />
      )}
    </div>
  );
};
